import React from 'react';
import S from '../../UmbracoForm.styles';
const Textfield = React.forwardRef(({ field, error, ...otherProps }, ref) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(S.Field, { className: error?.message && 'invalid' },
            React.createElement(S.Label, { htmlFor: field.alias },
                field.caption,
                field.required && React.createElement(React.Fragment, null, "*")),
            React.createElement(S.Input, { ref: ref, id: field.alias, placeholder: field.placeholder, required: field.required, ...otherProps }),
            error && React.createElement(S.Error, null, error.message)),
        field.alias === 'postcode' && React.createElement("div", null)));
});
Textfield.displayName = 'Textfield';
export default Textfield;
